import { render, staticRenderFns } from "./CategorySidebar.vue?vue&type=template&id=3f299aa9&scoped=true"
import script from "./CategorySidebar.vue?vue&type=script&lang=ts"
export * from "./CategorySidebar.vue?vue&type=script&lang=ts"
import style0 from "./CategorySidebar.vue?vue&type=style&index=0&id=3f299aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f299aa9",
  null
  
)

export default component.exports